import { useEffect, useState } from 'react';
import Select from './Select';
import Input from './Input';
import { Phone } from 'lucide-react';
import { validate_phone_number } from '../utils/validate';
import { cn } from '../shadcn/utils';
import { CARRIERS_BY_OPERATOR, PHONE_PREFIXES, PHONE_PLACEHOLDER, PHONE_INTERPOLATION, PREFIX_PLACEHOLDER } from '../utils/constants';


export default function PhoneInput({ country, onChange, disabled, className, value, operator }: { country: string; onChange: (value: string) => void; disabled?: boolean; className?: string; value?: string; operator?: keyof typeof CARRIERS_BY_OPERATOR }) {
  const PREFIX_LENGTH = country === 'peru' ? 1 : country === 'venezuela' ? 4 : 3;

  const [phonePrefix, setPhonePrefix] = useState(country === 'peru' ? '9' : value && validate_phone_number(value, country) ? value.slice(0, PREFIX_LENGTH) : '');
  const [phone, setPhone] = useState(value && validate_phone_number(value, country) ? value.slice(PREFIX_LENGTH) : '');

  useEffect(() => {
    if (value && validate_phone_number(value, country)) {
      setPhonePrefix(value.slice(0, PREFIX_LENGTH));
      setPhone(value.slice(PREFIX_LENGTH));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handlePrefixChange = (prefix: string) => {
    setPhonePrefix(prefix);
    onChange?.(prefix + phone);
  };

  const handlePhoneChange = (phoneNumber: string) => {
    setPhone(phoneNumber);
    onChange?.(phonePrefix + phoneNumber);
  };

  return (
    <div className={cn('flex gap-2', className)}>
      <Select
        containerClassName="w-[115px] shrink-0"
        placeholder={`${PREFIX_PLACEHOLDER[country as keyof typeof PREFIX_PLACEHOLDER]}`}
        Icon={<Phone className="size-4" />}
        defaultValue={phonePrefix}
        onSelectedChange={(value) => handlePrefixChange(value as string)}
        options={[
          ...(operator && CARRIERS_BY_OPERATOR[operator as keyof typeof CARRIERS_BY_OPERATOR]
            ? CARRIERS_BY_OPERATOR[operator as keyof typeof CARRIERS_BY_OPERATOR]
              : PHONE_PREFIXES?.[country as keyof typeof PHONE_PREFIXES] || [])
        ].map((prefix) => ({ label: prefix, value: prefix }))}
        floatingLabel="Código de area"
        disabled={disabled}
      />
      <Input
        disabled={!phonePrefix || disabled}
        containerClassName="grow"
        value={phone}
        onChange={(value) => handlePhoneChange(value?.trim())}
        type="tel"
        placeholder={PHONE_PLACEHOLDER[country as keyof typeof PHONE_PLACEHOLDER]}
        interpolation={PHONE_INTERPOLATION[country as keyof typeof PHONE_INTERPOLATION]}
        allowedChars="numbers_only"
        validation={(value) => validate_phone_number(`${phonePrefix}${value?.trim()}`, country)}
        floatingLabel={`Teléfono (${(PHONE_PLACEHOLDER?.[country as keyof typeof PHONE_PLACEHOLDER]?.split('X')?.length || 8) - 1} dígitos)`}
      />
    </div>
  );
}
